import { DataBean } from "../DataBean";


export class CreditAccountvdos extends DataBean {


    public async getCreditAccountCatalogPorPropiedades(properties:any,maxRows:any): Promise<any> {
        return this.getCustomService("CreditCore", "java.util.List_getCreditAccountCatalogPorPropiedades_java.util.Map_Number", [properties,maxRows]);
    }

     public async getCarteraRender(page:any,rows:any,Props:any): Promise<any> {
        return this.getCustomService("CreditCore", "com.advantage.shared.Report_getCarteraRender_Number_Number_java.util.Map", [page,rows,Props]);
    }
     public async getStateCreditPaymentReport(periodo:number,props:any): Promise<any> {
        return this.getCustomService("CreditCore", "com.advantage.shared.Report_getStateCreditPaymentReport_Number_java.util.Map", [periodo,props]);
    }

}